import ChannelSidebar from './ChannelSidebar'

export default ChannelSidebar
